import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Label } from "./primitives";
import guidePortrait from "../../assets/guide.jpg";

const PORTRAIT = guidePortrait;

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="relative py-24 md:py-32 px-6 md:px-10 overflow-hidden"
    >
      <div className="aura w-[420px] h-[420px] bottom-0 -left-20" />
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-14 md:gap-20 items-center">
        <Reveal>
          <div className="relative">
            <div className="relative overflow-hidden rounded-t-[180px] rounded-b-2xl border border-[#D4AF37]/20 aspect-[3/4] max-w-md">
              <motion.img
                style={{ y }}
                src={PORTRAIT}
                alt="Ishita Dhar"
                loading="lazy"
                decoding="async"
                className="w-full h-[110%] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#07040D]/60 to-transparent" />
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <Label>Meet Your Guide</Label>
            <h2 className="mt-5 font-serif-display font-light text-4xl sm:text-6xl text-[#EAE0D5] tracking-tight leading-none">
              Ishita <span className="italic text-[#D4AF37]">Dhar</span>
            </h2>
            <p className="mt-4 text-xs sm:text-sm tracking-[0.16em] uppercase text-[#D4AF37]/90">
              Tarot Reader · Psychic Intuitive · Energy Healer · Spiritual Guide
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-[#A89FA8] leading-relaxed max-w-lg">
              <p>
                With over 12 years of experience, my own journey through life,
                healing, meditation and self-reflection has taught me that
                healing isn't about finding all the answers — it's about
                understanding yourself more deeply and reconnecting with your
                inner wisdom. I see tarot as a tool for clarity, self-awareness,
                intuitive guidance, healing and empowerment, not simply
                predicting a fixed future.
              </p>
              <p>
                Whether you're navigating love, relationships, career, self-worth
                or a life transition, my sessions offer a safe, compassionate
                space to pause, reflect and see things from a new perspective.
              </p>
              <p>
                I don't just look at the cards; I look at the person behind the
                questions. You don't need to have all the answers — you simply
                need to be willing to look within. I'd be honoured to walk
                alongside you.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex gap-10">
              <div>
                <div className="font-serif-display text-4xl text-[#D4AF37]">
                  7500+
                </div>
                <div className="text-xs tracking-[0.18em] uppercase text-[#756D7A] mt-1">
                  Readings Held
                </div>
              </div>
              <div>
                <div className="font-serif-display text-4xl text-[#D4AF37]">
                  12 yrs
                </div>
                <div className="text-xs tracking-[0.18em] uppercase text-[#756D7A] mt-1">
                  Of Practice
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
